import phillipeListing from '../../assets/provider-testimonies/percyListing.JPG';
import thereseListing from '../../assets/provider-testimonies/lolyListing.png';
import stellaListing from '../../assets/provider-testimonies/luisListing.JPG';
import phillipeAvatar from '../../assets/provider-testimonies/percy.PNG';
import thereseAvatar from '../../assets/provider-testimonies/loly.png';
import stellaAvatar from '../../assets/provider-testimonies/luis.PNG';

export const linksProps = {
  review1: {
    id: '5ed18905-928f-42ce-80f9-7277d8ef5ccd',
    image: phillipeListing,
    reviewContent: "Compartir tu piscina, ver gente disfrutando en tu casa y tener ingresos, me genera felicidad y tranquilidad. Y con el equipo humano de Swimmy que es muy dedicado y eficaz, tienes seguridad.",
    provider: {
      avatar: phillipeAvatar,
      displayName: 'Percy',
    },
  },
  review2: {
    id: '60ddc29f-7bdc-4bd0-b034-73bb8febe936',
    image: thereseListing,
    reviewContent: "En comparación, lo veo como una de las aplicaciones más serias. Es con la que más tengo afinidad, estoy muy contento. Me parece una excelente idea por la zona nuestra de Madrid, ya que no tenemos playa. Creo que más que un comercio es una necesidad para la sociedad.",
    provider: {
      avatar: thereseAvatar,
      displayName: 'Ricardo',
    },
  },
  review3: {
    id: '5d5a6a54-1af0-4f15-b550-487e9d9382de',
    image: stellaListing,
    reviewContent: "Swimmy hace muy fácil poner tu piscina a disposición de otras personas. Todo se gestiona a través de su plataforma de una manera muy sencilla. Estamos encantados con Swimmy, nunca hemos tenido ningún problema.",
    provider: {
      avatar: stellaAvatar,
      displayName: 'Luis',
    },
  },
};
